var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircleDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1703 44.1333L24.937 32.9333C24.8036 32.8 24.7094 32.6556 24.6543 32.5C24.5983 32.3444 24.5703 32.1778 24.5703 32C24.5703 31.8222 24.5983 31.6556 24.6543 31.5C24.7094 31.3444 24.8036 31.2 24.937 31.0667L36.1703 19.8333C36.4814 19.5222 36.8703 19.3667 37.337 19.3667C37.8036 19.3667 38.2036 19.5333 38.537 19.8667C38.8703 20.2 39.037 20.5889 39.037 21.0333C39.037 21.4778 38.8703 21.8667 38.537 22.2L28.737 32L38.537 41.8C38.8481 42.1111 39.0036 42.4942 39.0036 42.9493C39.0036 43.4053 38.837 43.8 38.5036 44.1333C38.1703 44.4667 37.7814 44.6333 37.337 44.6333C36.8925 44.6333 36.5036 44.4667 36.1703 44.1333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleDark);
export default __webpack_public_path__ + "static/media/ArrowCircleDark.28282deee6227b4ffa6cead767de4539.svg";
export { ForwardRef as ReactComponent };